import React         from 'react';
import { Translate } from 'react-localize-redux';
import styled        from 'styled-components';
import ImgFrame      from './images/popup_bg.png';
import Section       from './section';
import titleImg      from './images/title/Notice.png';

/**
 * Number of warnings to display
 * Must correspond with locale file
 */
const numberOfWarnings = 12;

const Container = styled.div`
  text-align:center;
`;

const Table = styled.div`
  align-items          : center;
  display              : grid;
  grid-gap             : 0 1.2em;
  grid-template-columns: auto 1fr;
  font-size            : 2vw;
  margin               : 1em auto 1em;
  padding              : 4vw 1vw 2vw 1vw;
  width                : 60vw;
  height               : 60vw;
  max-width            : 768px;
  max-height           : 768px;

  background-repeat    : no-repeat;
  background-size      : contain;
  background-position  : center center;
  background-image     : url(${ImgFrame});

  @media (min-width: 1242px) {
    padding  : 2em 1em 2em 1em;
    font-size: 25px;
  }
`;

const List = styled.ol`
  position   : absolute;
  margin-top : 0vw;
  margin-left: 0vw;
`;

const Text = styled.li`
  color         : black;
  line-height   : 1.5;
  text-align    : left;

  margin-top: 0.7vw;
  width: 50vw;

  @media (min-width: 1242px) {
    margin-top: 0.5em;
    width: 28em;
  }
`;

/**
 * Warning section
 */
const Warning = (onLoad, data) => (
    <Container>
      <Section imgSrc={titleImg} >
       <Table>
       <List>
         {Array.from(Array(numberOfWarnings).keys()).map(i => (
           <Text key={i}>
             <Translate id={`landingPage.warning.${i + 1}`} />
           </Text>
         ))}
       </List>
       </Table>
     </Section>
    </Container>
);

export default Warning;
